import React from 'react';

type Props = {
  // 見えるかどうか
  isVisible: boolean;
  // テキスト
  text: string;
};

const VisibilitySpan = React.memo<Props>((props) => (
  <span style={{ visibility: props.isVisible ? 'visible' : 'hidden' }}>
    {props.text}
  </span>
));

export default VisibilitySpan;
